import type CalendarCloudSetting from '../store/schema/CalendarCloudSetting';
import type CalendarCloudSettingsOptions from '../store/schema/CalendarCloudSettingsOptions';
import { CalendarCloudSettingSourceType } from '../store/schema/CalendarCloudSettingSourceType';
import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';

/**
 * Converts the OCS settings or prime settings to the CalendarCloudSettings
 * @param options
 */
export default function convertOptionsToCalendarCloudSettings(
    options: CalendarCloudSettingsOptions
): CalendarCloudSetting[] | null {
    if (!options) {
        return null;
    }

    const calendarCloudSettings: CalendarCloudSetting[] = [];

    if (options.shouldEventsEndEarly != null) {
        calendarCloudSettings.push({
            name: CalendarCloudSettingType.ShouldEventsEndEarly,
            value: options.shouldEventsEndEarly,
            source: CalendarCloudSettingSourceType.UserOverride,
        });
    }

    if (options.shortenEventScope != null) {
        calendarCloudSettings.push({
            name: CalendarCloudSettingType.ShortenEventScope,
            value: options.shortenEventScope,
            source: CalendarCloudSettingSourceType.UserOverride,
        });
    }

    if (options.endShortEventsBy != null) {
        calendarCloudSettings.push({
            name: CalendarCloudSettingType.EndShortEventsBy,
            value: options.endShortEventsBy,
            source: CalendarCloudSettingSourceType.UserOverride,
        });
    }

    if (options.endLongEventsBy != null) {
        calendarCloudSettings.push({
            name: CalendarCloudSettingType.EndLongEventsBy,
            value: options.endLongEventsBy,
            source: CalendarCloudSettingSourceType.UserOverride,
        });
    }

    if (options.enableOnlineMeetingsByDefault != null) {
        calendarCloudSettings.push({
            name: CalendarCloudSettingType.EnableOnlineMeetingsByDefault,
            value: options.enableOnlineMeetingsByDefault,
            source: CalendarCloudSettingSourceType.UserOverride,
        });
    }

    if (options.roamingTimezones != null) {
        calendarCloudSettings.push({
            name: CalendarCloudSettingType.RoamingTimezones,
            value: options.roamingTimezones,
            source: CalendarCloudSettingSourceType.UserOverride,
        });
    }

    if (options.primaryTimezoneLabel != null) {
        calendarCloudSettings.push({
            name: CalendarCloudSettingType.PrimaryTimezoneLabel,
            value: options.primaryTimezoneLabel,
            source: CalendarCloudSettingSourceType.UserOverride,
        });
    }

    return calendarCloudSettings.length === 0 ? null : calendarCloudSettings;
}
